import { Component, inject, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { FaqService } from "@features/about/services/faq.service";
import { SubPageComponent } from "@shared/components";
import { FaqCategory } from "@shared/enums";
import { GlobalService } from "@shared/services";
import { AccordionModule } from "primeng/accordion";
import { Subscription } from "rxjs";

@Component({
  selector: "app-faq",
  standalone: true,
  imports: [SubPageComponent, AccordionModule],
  templateUrl: "./faq.component.html",
  styleUrl: "./faq.component.scss",
})
export class FaqComponent implements OnInit, OnDestroy {
  faqService = inject(FaqService);
  globalService = inject(GlobalService);
  activatedRoute = inject(ActivatedRoute);

  routeSubscription: Subscription | null = null;
  faqs: any;
  faqGroup: string = "";
  pageTitle: string = "";

  ngOnInit(): void {
    this.routeSubscription = this.activatedRoute.params.subscribe((params) => {
      this.faqGroup = params["category"];
    });
    this.setFaqs();
  }

  ngOnDestroy(): void {
    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
    }
  }

  getContainerHeight(): string {
    return `calc(100vh - ${this.globalService.navbarHeight()}px)`;
  }

  setPageTitle() {
    switch (this.faqGroup) {
      case "imax":
        this.pageTitle = "IMAX Strategy";
        break;
      case "plans":
        this.pageTitle = "Plans";
        break;
      case "charts":
        this.pageTitle = "Offline";
        break;
      default:
        this.pageTitle = "FAQ";
    }
  }

  setFaqs(): void {
    switch (this.faqGroup) {
      case "imax":
        this.faqs = this.faqService.getFaqsByCategory(FaqCategory.IMAX_STRATEGY);
        break;
      case "plans":
        this.faqs = this.faqService.getFaqsByCategory(FaqCategory.PLANS);
        break;
      case "offline":
        this.faqs = this.faqService.getFaqsByCategory(FaqCategory.OFFLINE);
        break;
      default:
        this.faqs = this.faqService.getFaqsByCategory(FaqCategory.IMAX_STRATEGY);
        break;
    }
    console.log(this.faqs);
  }
}
